import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-icon-loader',
  templateUrl: './icon-loader.component.html',
  styleUrls: ['./icon-loader.component.scss','./icon-loader.component.rtl.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class IconLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
